<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><span aria-label="iii" class="page" id="piii" role="doc-pagebreak"></span>A Union Like Ours</h1>
<h1 class="bk1"><span class="page" data-locator="piii"></span>The Love Story of F. O. Matthiessen and Russell Cheney</h1>
<p class="bkau">Scott Bane</p>
<p class="bkpub"><span class="page" data-locator="piii"></span>Bright Leaf</p>
<p class="pcust1">BOOKS THAT ILLUMINATE</p>
<p class="bkpub1">Amherst and Boston</p>
<p class="pcust2">An imprint of University of Massachusetts Press</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// uma_Bane0004.vue?0c834b4c